import { render, staticRenderFns } from "./CreateRoErrorBanner.vue?vue&type=template&id=56342d07&scoped=true&"
import script from "./CreateRoErrorBanner.vue?vue&type=script&lang=js&"
export * from "./CreateRoErrorBanner.vue?vue&type=script&lang=js&"
import style0 from "./CreateRoErrorBanner.vue?vue&type=style&index=0&id=56342d07&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56342d07",
  null
  
)

export default component.exports